import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b95144b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recipient-selector-container" }
const _hoisted_2 = { class: "search-area" }
const _hoisted_3 = { class: "mt-4 is-flex is-justify-content-space-evenly is-align-items-center custom-search-bar" }
const _hoisted_4 = { class: "search-bar-container" }
const _hoisted_5 = { class: "control has-icons-left custom-search-bar" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "icon is-small is-left" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container is-fluid custom-heavy-line-separator" }, null, -1))
const _hoisted_9 = { class: "custom-card is-flex-direction-column is-align-items-center is-justify-content-space-between" }
const _hoisted_10 = {
  key: 2,
  class: "is-flex is-align-items-center is-justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_RecipientItem = _resolveComponent("RecipientItem")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recipientsSearchString) = $event)),
              onInput: _cache[1] || (_cache[1] = 
                (e) => {
                  ;(_ctx.recipientsSearchString = e.target.value),
                    _ctx.recipientsSearchString.length === 0 ||
                    _ctx.recipientsSearchString.length >= 3
                      ? _ctx.recipientBatchLoader.newGen(_ctx.recipientsSearchString)
                      : null
                }
              ),
              class: "input",
              type: "text",
              placeholder: _ctx.$gettext('Name, email address or phone number'),
              ref: "searchRecipient"
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.recipientsSearchString]
            ]),
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_fa_icon, { icon: "search" })
            ])
          ])
        ]),
        _createElementVNode("span", {
          class: "icon is-small",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startScan && _ctx.startScan(...args)))
        }, [
          _createVNode(_component_fa_icon, {
            class: "qrcode-icon",
            icon: "qrcode"
          })
        ])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("section", {
      class: "modal-card-body",
      ref: "recipientsContainer",
      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.recipientBatchLoader.getNextElements && _ctx.recipientBatchLoader.getNextElements(...args)))
    }, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.getRecipients)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getRecipients, (recipient, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "is-clickable py-2",
                key: index
              }, [
                _createVNode(_component_RecipientItem, {
                  recipient: recipient,
                  onMousedown: _withModifiers(($event: any) => (
                "// on some android, input gets a change event"
              ), ["prevent"]),
                  onSelect: ($event: any) => (_ctx.handleClickRecipient(recipient))
                }, null, 8, ["recipient", "onMousedown", "onSelect"])
              ]))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.recipientBatchLoader.isNewBatchLoading.value)
          ? (_openBlock(), _createBlock(_component_loading, {
              key: 1,
              active: _ctx.recipientBatchLoader.isNewBatchLoading.value,
              "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.recipientBatchLoader.isNewBatchLoading.value) = $event)),
              "can-cancel": false,
              "is-full-page": false,
              width: 30,
              height: 30,
              class: "loader-container"
            }, null, 8, ["active"]))
          : _createCommentVNode("", true),
        (
            _ctx.recipientBatchLoader?.hasNoMoreElements.value &&
            _ctx.ownCurrenciesRecipients.length === 0
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$gettext("No recipients found")), 1))
          : _createCommentVNode("", true)
      ])
    ], 544)
  ]))
}